import React from 'react';
import BasicConfig from "../cmsbase/BasicConfig";
import {digitalSignageConfigurationFormFields} from "../../network/mockData";

function Configuration(props) {
    console.log("configuration");
    return (
        <BasicConfig
            title="Basic config form"
            formFields={digitalSignageConfigurationFormFields}
            dataUrl="mock/digitalsignage/admin/hub-id/configuration"
        />
    );
}

export default Configuration;